export default "__VITE_ASSET__c9d75a04__"